module.exports = __webpack_public_path__ + "static/media/laryngectomie_icon_store.2af18b82.png";